import { render, staticRenderFns } from "./SalaryRulesView.vue?vue&type=template&id=2a529bee&"
import script from "./SalaryRulesView.vue?vue&type=script&lang=js&"
export * from "./SalaryRulesView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports